<template>
  <div class="container">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div class="mt-4 mb-5" style="max-width:560px">
        <h3>Synkroniser fakturaordrer til Tripletex</h3>

        <div v-show="!loading">
            <div v-if="locations.length === 0" class="mt-4">
              <span class="message-info">Ingen avdelinger har Tripletex aktivert. Aktiver det under Avdelinger.</span>
            </div>

            <div v-else-if="!configured" class="mt-4">
              <span class="message-info">Tripletex-konto er ikke konfigurert for denne avdelingen. Gå til <a href="/tripletex">Tripletex innstillinger</a> for å sette opp.</span>
            </div>

            <div v-if="configured">
                <div v-if="hasMultiLocations()" class="mt-4">
                  <span class="ingredient-title">Velg avdeling</span>
                  <select class="form-select" v-model="locationId" @change="onLocationChange()">
                    <option v-for="(location, index) in locations" :key="index" :value="location.id">{{ location.name }}</option>
                  </select>
                </div>

                <div class="mt-4">
                  <p class="text-muted">Synkroniser ordrer betalt med faktura til Tripletex.</p>
                  <SelectDate ref="selectDateFrom" label="Velg fra og med dato"/>
                  <SelectDate ref="selectDateTo" label="Velg til og med dato"/>
                  <button type="button" class="bo_btn mt-2" @click="syncOrders"> Synkroniser fakturaordrer til Tripletex </button>

                  <div v-if="syncCompleted" class="mt-3">
                    <div :class="syncResult.success ? 'message-success' : 'message-error'">
                      <p>{{ syncResult.message }}</p>
                      <p v-if="syncResult.successCount !== undefined">Synkronisert: {{ syncResult.successCount }} | Hoppet over: {{ syncResult.skippedCount }} | Feil: {{ syncResult.errorCount }}</p>
                    </div>
                    <div v-if="syncResult.errors" class="mt-2">
                      <span class="ingredient-title">Feildetaljer:</span>
                      <ul>
                        <li v-for="(error, index) in syncResult.errors" :key="index">{{ error }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
  import LoadingSpinner from "@/components/other/LoadingSpinner";
  import SelectDate from "@/components/other/SelectDate";
  import SettingsService from "@/services/settings/SettingsService";
  import LocationUtil from "@/util/LocationUtil";
  import LocationService from "@/services/location/LocationService";

  export default {
    components: {LoadingSpinner, SelectDate},
    data() {
      return {
        loading: true,
        locationId: '',
        locations: [],
        configured: false,
        syncCompleted: false,
        syncResult: {}
      };
    },
    mounted() {
      LocationService.listLocations().then(
          (response) => {
            this.locations = response.data.filter(l => l.accountingSystem === 'TRIPLETEX');
            this.locationId = this.locations.length ? this.locations[0].id : '';

            if (this.locationId) {
              this.checkSyncStatus();
            } else {
              this.configured = false;
              this.loading = false;
            }
          },
          (error) => {
            console.log(error);
          }
      );
    },
    methods: {
      hasMultiLocations(){
        return LocationUtil.hasMultiLocations();
      },
      onLocationChange(){
        this.syncCompleted = false;
        this.checkSyncStatus();
      },
      checkSyncStatus(){
        SettingsService.getTripletexSyncStatus(this.locationId).then(
            (response) => {
              if(response.data !== null){
                this.configured = response.data.configured;
              }
              this.loading = false;
            },
            (error) => {
              console.log(error);
              this.loading = false;
            }
        );
      },
      syncOrders(){
        this.loading = true;
        this.syncCompleted = false;
        let fromDate = this.$refs.selectDateFrom.getSelectedDate();
        let toDate = this.$refs.selectDateTo.getSelectedDate();

        SettingsService.syncOrdersToTripletex(this.locationId, fromDate, toDate).then(
            (response) => {
              this.syncCompleted = true;
              this.syncResult = response.data;
              this.loading = false;
            },
            (error) => {
              this.syncCompleted = true;
              this.syncResult = { success: false, message: 'Feil ved synkronisering' };
              console.log(error);
              this.loading = false;
            }
        );
      }
    }
  };
</script>
